import React from "react";
import {ContextMenu, MenuItem} from "react-contextmenu";
import Provider from "pubsub-js";
import Mediator from "../../services/Mediator";
import {HAS_COPIED_OBJECT} from "../../constants/event-types";

class CtxMenu extends React.Component {
  state = {
    hasCopiedObject: false
  };
  componentDidMount() {
    Provider.subscribe(HAS_COPIED_OBJECT, () => {
      this.setState({
        hasCopiedObject: true
      });
    });
  }
  componentWillUnmount() {
    Provider.unsubscribe(HAS_COPIED_OBJECT);
  }
  render() {
    const items = [
      {
        name: `Выделить все`,
        hotKey: `Ctrl+A`,
        handleClick: handlers.onSelectAll
      },
      {
        name: `Вставить`,
        icon: `far fa-clipboard`,
        hotKey: `Ctrl+V`,
        disabled: !this.state.hasCopiedObject,
        handleClick: handlers.onPaste
      }
    ];
    return (
      <ContextMenu id="context-menu" className="context-menu">
        {items.map((item) => {
          const {name, icon, handleClick, hotKey, disabled} = item;
          return (
            <MenuItem key={name} onClick={handleClick} disabled={disabled}>
              <span className="context-menu-item__content">
                {icon && <i className={`context-menu-item__icon ${icon}`} />}
                <span className="context-menu-item__text">{name}</span>
              </span>
              {hotKey && (
                <span className="context-menu-item__hot-key">{hotKey}</span>
              )}
            </MenuItem>
          );
        })}
      </ContextMenu>
    );
  }
}

const handlers = {
  onPaste() {
    Mediator.pasteCopiedObject();
  },
  onSelectAll() {
    Mediator.selectAllObjects();
  }
};

export default CtxMenu;
